import Modal from 'react-bootstrap/Modal'
import { CgClose } from 'react-icons/cg'
import { HomeVideoPlayer } from './HomeVideoPlayer'

const VideoModal = (props) => {
  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      style={{ backgroundColor: 'transparent' }}
      className='home-page'
    >
      <div className='p-5' style={{ margin: '0 auto', width: 'fit-content', position: 'relative' }}>
      <span onClick={props.onHide} style={{position: 'absolute', top: 0, right: 0, cursor: 'pointer'}}>
        <CgClose color='#fff' fontSize={30} />
      </span>
        <HomeVideoPlayer />
      </div>
    </Modal>
  )
}
export default VideoModal
